import { Button, Form, Modal, message } from "antd";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import ModalHeaderText from "../../common/ModalHeaders/ModalHeaderText";
import TextArea from "../UiTextArea/TextArea";
import useForm from "../../common/hooks/useForm";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, notification } from "antd";
import { saveDeactiveEmployeeDetails } from "../../redux/DeactiveEmployee/action";
import useSession from "../CustomLogout/useSession";
import { deletePartnerUserRole } from "../../redux/AddUserDetails/action";
import { useDispatch } from "react-redux";
const DeactivatePartnerUser = ({
  setPartnerRefresh,
  partnerRefresh,
  drawerOpen,
  setDrawerOpen,
  ...props
}) => {
  const handleSessionExpired = useSession();
  const { state, onChangeTextHandler } = useForm();
  const [form] = Form.useForm();
  const [saveLoading, setSaveLoading] = useState(false);
  const dispatch = useDispatch();

  const handleDeactivateUser = () => {
    setSaveLoading(true);
    const deactivateData = {
      userId: props.row?.original?.userId,
      active: false,
      deactiveReason: state.deactiveReason.trim(),
    };

    dispatch(
      deletePartnerUserRole({
        values: deactivateData,
        access_token: props.access_token,
      })
    )
      .then((res) => {
        setSaveLoading(false);
        if (res && res.status === 200) {
          setTimeout(() => {
            message.success("User Deactivated");
          }, 2000);
          handleCancel();
          setPartnerRefresh(true);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((e) => {
        setSaveLoading(false);
      });
  };

  const handleCancel = () => {
    setDrawerOpen(false);
    form.resetFields();
  };

  return (
    <div className="deactivate-partner-sec">
      <Modal
        open={drawerOpen}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Form
          autoComplete="off"
          name="deactivatePartner"
          layout="vertical"
          form={form}
          onFinish={handleDeactivateUser}
        >
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <Col md={12} className="headre-login">
                <ModalHeaderText LoginHeading="Deactivate User" />
              </Col>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={12}>
              <p>
                By Clicking on confirm, the user will be deactivated and will
                not be able to add leads into the system. However his earlier
                leads will still be active and accessible to the Avanse Teams.
              </p>
            </Col>
          </Row>
          <Row className="form-group">
            <Col md={12}>
              <TextArea
                type="text"
                onInput={(e) => {
                  if (e.target.value.trim() == "") {
                    e.target.value = e.target.value.trim();
                  }

                  if (e.target.value.trim() !== "") {
                    e.target.value = e.target.value.trimStart();
                  }
                }}
                title="Reason of Deactivation"
                id="reasonOfDeactivation"
                maxLength={255}
                placeholder="Enter Reason of Deactivation"
                autoComplete="off"
                className="floating-input floating-textarea"
                rows={4}
                validation={[
                  {
                    required: true,
                    message: "Please Enter Reason of Deactivation",
                  },
                ]}
                name="deactiveReason"
                onChange={onChangeTextHandler}
              />
            </Col>
          </Row>
          <Row className="">
            <Col md={12} className="d-flex justify-content-end">
              {saveLoading && (
                <div className="pr-4 spanner">
                  <Spin
                    size="large"
                    className="pr-4"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              )}
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button className="" htmlType="submit" type="primary">
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveDeactiveEmployeeDetails: (data) =>
      dispatch(saveDeactiveEmployeeDetails(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeactivatePartnerUser);
